import React, { useContext } from "react"
import { PCViewContext } from "../Common/PCViewContext"
import Title from "./Title"
import Filter from "./Filter"
import ResultSet from "./ResultSet"

import * as styles from "./Styles/Container.module.scss"

const Contents = (props) => {
  return (
    <React.Fragment>
      <Title {...props} />
      <Filter location={props.prefecture} {...props} />
      <ResultSet {...props} />
    </React.Fragment>
  )
}

const Container = (props) => {
  const isPC = useContext(PCViewContext)

  return (
    <div className={styles.container}>
      {isPC && (
        <div className={styles.inner}>
          <Contents {...props} />
        </div>
      )}
      {!isPC && <Contents {...props} />}
    </div>
  )
}

export default Container
